"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleHtml = `<html>
<head>
  <link
    href="https://fonts.googleapis.com/css?family=Fontdiner+Swanky|Knewave|Megrim|IBM+Plex+Sans"
    rel="stylesheet"
  />
  <style>
    body {
      background-image: url(https://storage.googleapis.com/img.stage.osmosys.app/charley@yellowbrim.com/1/2019/03/03/23/bananas.png);
    }
    .plex {
      font-family: 'IBM Plex Sans', sans-serif;
    }
    .knewave {
      font-family: 'Knewave', Arial, Helvetica;
    }
    .megrim {
      font-family: 'Megrim', Arial, Helvetica;
    }
    .swanky {
      font-family: 'Fontdiner Swanky', Arial, Helvetica;
    }
    table {
      max-width: 600px;
      width: 100%;
      margin: 0 auto;
    }
    h2, h3, h4, h5, a {
      color: #005C72;
    }
    h1 {
      color: #00ceff;
    }
    a {
      text-decoration: underline;
    }
    hr {
      color: #48BBC2;
      border-left: 0;
      border-right: 0;
      border-top: 5px solid #48BBC2;
      border-bottom: 0;
    }
    .text-bold {
      font-weight: bold;
    }
    .text-center {
      text-align: center;
    }
    .padding {
      padding: 20px;
    }
    .bg-light {
      background-color: #E6F4F1;
    }
    .bg-danger {
      background-color: #A63B00;
    }
    .bg-danger a {
      color: #ffffff;
    }
    .bg-white {
      background-color: #ffffff;
    }
    .text-white {
      color: #ffffff;
    }
  </style>
</head>
<body class="padding bg-light plex">
  <table class="padding bg-white">
    <tr>
      <td class="text-center">
        <p class="text-bold megrim">An Osmosys Template</p>
        <h1 class="swanky ">Around The Brim</h1>
        <hr />
      </td>
    </tr>
    <tr>
      <td>
        <div
          class="padding bg-light text-bold"
          osys
          osys:group
          osys:name="Promotion"
          osys:hideable
        >
          <a
            href="https://osmosys.app"
            osys
            osys:field
            osys:field:type="url"
            osys:field:target="href"
            osys:name="Promo link"
          >
            <strong>Promoted:</strong>
            <span
              osys
              osys:field
              osys:field:type="html"
              osys:name="Promo text"
              >Subscribe today!</span>
          </a>
        </div>
        <h1
          osys
          osys:field
          osys:name="Heading 1"
          osys:field:source="Catch phrase"
          osys:field:target="children"
          osys:field:type="text"
        >
          Headline 1
        </h1>
        <h2
          osys
          osys:field
          osys:name="Subheading 1"
          osys:field:source="Catch phrase"
          osys:field:target="children"
          osys:field:type="text"
          osys:hideable
        >
          Headline 2 (this block is hideable)
        </h2>
        <div
          osys
          osys:name="Example ad"
          osys:field
          osys:field:type="ad"
        >
          First ad code inserted here
        </div>
        <div
          osys
          osys:field
          osys:name="Content"
          osys:field:source="Catch phrase"
          osys:field:target="children"
          osys:field:type="html"
          osys:hideable
          osys:hidden
        >
          <p>
            HTML goes here.
          </p>
          <p>
            <marquee>Test</marquee>
          </p>
        </div>
        <a
          href="#"
          osys
          osys:field
          osys:name="Image link"
          osys:field:type="url"
          osys:field:target="href"
          osys:hideable
        >
          <img
            osys
            osys:field
            osys:name="Image"
            osys:field:source="image"
            osys:field:target="src"
            osys:field:type="url"
            src="https://via.placeholder.com/350x150"
            style="max-width: 500px;"
          />
        </a>
        <div
          osys
          osys:repeater
          osys:repeater:min="2"
          osys:repeater:default="3"
          osys:repeater:max="5"
        >
          <h2
            osys
            osys:field
            osys:field:target="children"
            osys:field:type="text"
          >
            This is not a valid repeater child
          </h2>
          <div
            osys
            osys:field
            osys:field:target="children"
            osys:field:type="html"
          >
            This is not a valid repeater child
          </div>
        </div>
        <div
          osys
          osys:repeater
          osys:repeater:min="2"
          osys:repeater:default="3"
          osys:repeater:max="5"
        >
          <div
            osys
            osys:repeat
            osys:name="Repeatable Ad"
            osys:field
            osys:field:type="ad"
          >
            First ad code inserted here
          </div>
          <div osys osys:repeat osys:group>
            <h2
              osys
              osys:field
              osys:name="Phrase that is catch"
              osys:field:source="Catch phrase"
              osys:field:target="children"
              osys:field:type="text"
            >
              Headline 2
            </h2>

            <a
              href="#"
              osys
              osys
              osys:field
              osys:field:target="href"
              osys:name="Image link"
            >
              <img
                osys
                osys:field
                osys:name="Image"
                osys:field:source="image"
                osys:field:target="src"
                osys:field:type="text"
                src="https://via.placeholder.com/350x150"
              />
            </a>
          </div>
        </div>
        <div osys>This block is unknown. I think the contents should be deleted OR should be left alone explicitly.</div>
        <br />
        <br />
        <hr />
        <br />
        <div osys osys:name="Converted group Roundup-section" osys:group>
          <a osys osys:field osys:field:target="href" osys:name="Image link">
            <img osys osys:field osys:field:target="src" osys:name="Image URL" />
          </a>
          <h5>Roundup #1:</h5>
          <div osys osys:field osys:name="Roundup #1">Lorem ipsum</div>
          <h5>Roundup #2:</h5>
          <div osys osys:field osys:name="Roundup #2">Foobar</div>
          <h5>Roundup #3:</h5>
          <div osys osys:field osys:name="Roundup #3">Hello world</div>
        </div>
        <br />
        <hr />
        <p class="text-center">
          &copy; 2019 Yellow Brim LLC
        </p>
      </td>
    </tr>
  </table>
</body>
</html>

`;
//# sourceMappingURL=sampleHtml.js.map